import React from 'react';
import EliasBackButton from '../../../atoms/EliasBackButton/EliasBackButton';
import ROUTER_URLS from '../../../utils/router/urls';
import Dashboard from '../../../compounds/Dashboard/Dashboard';
import { fetchWnbaPlayerStreakStats } from '../../../../api/wnba';
import PlayerStreakFilters from '../../../compounds/PlayerStreakFilters/PlayerStreakFilters';
import ResultsLoading from '../../../compounds/ResultsLoading/ResultsLoading';
import PlayerStreakTable from '../../../compounds/PlayerStreakTable/PlayerStreakTable';
import { statsFilters, streakRangeOptions, PAGE_TITLE, PAGE_SUBTITLE } from './constants';
import EliasStatsFilter from '../../../compounds/EliasStatsFilter/EliasStatsFilter';
import API_URLS from '../../../../api/api_urls';
import { advancedModalFilterCategories, gameModalFilterCategories } from '../constants';
import ModalFilters from '../../../compounds/ModalFilters/ModalFilters';
import { ContextFilterType } from '../../../types/context';
import WnbaPlayerFiltersLayout from '../../../compounds/wnba/WnbaPlayerFiltersLayout';
import { mapRows } from '../../../utils/wnba/streak-finder/map-results';
import { mapColumns } from '../../../utils/wnba/streak-finder/map-columns';
import FinderStackLayout from '../../../compounds/FinderStackLayout/FinderStackLayout';
import withResultsLayout, { WithResultsLayoutProps } from '../../../compounds/ResultsWrapper/ResultsWrapper';
import { appendContextFilters } from '../../../utils/wnba/search';
import Header from '../../../compounds/Common/Header';
import EXTERNAL_URLS from '../../../utils/router/external_urls';

interface IProps extends WithResultsLayoutProps {};

function PlayerStreakFinderResults({
  columnHeaders,
  resultsData,
  tableDataLoading,
  filtersLoading,
  error,
  handleDone,
  pageOrSortDataFetch
}: IProps) {
  const pageSpecificSearchEnabled = (context: ContextFilterType): boolean =>
    Boolean(context.streakGameNumber) && Number(context.streakGameNumber) > 1;

  const statsFilterPartial = <EliasStatsFilter statsFilterOptions={statsFilters} displayYearInfo={false} />;
  const topModalPartial = (
    <ModalFilters
      buttonTitle='Game Type & Date Filters'
      filters={gameModalFilterCategories}
      filterType='gameTypeFilters'
    />
  );
  const bottomModalPartial = (
    <ModalFilters
      buttonTitle='Advanced Filters'
      filters={advancedModalFilterCategories}
      filterType='advancedFilters'
    />
  );

  return (
    <Dashboard loading={filtersLoading}>
      <FinderStackLayout
        header={
          <Header
            title={PAGE_TITLE}
            subtitle={PAGE_SUBTITLE}
            backButton={
              <EliasBackButton route={ROUTER_URLS.wnba.playerStreakFinderSearch} />
            }
          />
        }
        topPanel={
          <WnbaPlayerFiltersLayout
            handleDone={handleDone}
            statsFilterPartial={statsFilterPartial}
            pageSpecificSearchEnabled={pageSpecificSearchEnabled}
            apiUrls={API_URLS.wnba}
            topModalPartial={topModalPartial}
            bottomModalPartial={bottomModalPartial}
          >
            <PlayerStreakFilters streakRangeOptions={streakRangeOptions} />
          </WnbaPlayerFiltersLayout>
        }
        bottomPanel={
          tableDataLoading || error ?
          <ResultsLoading error={error} /> :
          <PlayerStreakTable
            data={resultsData?.results ?? []}
            dataCount={resultsData?.count ?? 0}
            dataMetaInfo={resultsData?.query?.back_to ?? []}
            columnData={columnHeaders || []}
            handleDone={pageOrSortDataFetch}
            linkUrls={EXTERNAL_URLS.WNBA}
          />
        }
      />
    </Dashboard>
  );
}

export default withResultsLayout(
  PlayerStreakFinderResults,
  ROUTER_URLS.wnba.playerStreakFinderResults,
  statsFilters,
  fetchWnbaPlayerStreakStats,
  mapColumns,
  mapRows,
  appendContextFilters,
);
